import React from "react";
import LegalPage, { useLegalInfo, Val, MissingFieldsBlock } from "./LegalPage";

export default function SalesTerms() {
  const info = useLegalInfo();
  return (
    <LegalPage overline="Document légal" title="Conditions de vente">
      <p><strong>Effective :</strong> <Val info={info} k="TERMS_EFFECTIVE_DATE" /></p>
      <p>
        Les présentes Conditions de vente s'appliquent à tout achat du Révélateur™ effectué depuis cette
        plateforme. Elles doivent être acceptées avant le paiement.
      </p>

      <h2>1. Identité du vendeur</h2>
      <ul>
        <li><strong>Nom commercial :</strong> Maison Beaudette™</li>
        <li><strong>Dénomination sociale légale :</strong> <Val info={info} k="LEGAL_BUSINESS_NAME" /></li>
        <li><strong>Adresse d'affaires :</strong> <Val info={info} k="BUSINESS_ADDRESS" /></li>
        <li><strong>Numéro d'entreprise :</strong> <Val info={info} k="BUSINESS_REGISTRATION_NUMBER" /></li>
        <li><strong>Renseignements de taxes :</strong> <Val info={info} k="TAX_REGISTRATION_INFORMATION" /></li>
        <li><strong>Soutien :</strong> <Val info={info} k="SUPPORT_EMAIL" /> · <Val info={info} k="BUSINESS_PHONE" /></li>
      </ul>

      <h2>2. Produit vendu</h2>
      <ul>
        <li><strong>Nom :</strong> Le Révélateur™</li>
        <li>
          <strong>Description :</strong> produit numérique unique. Accès en ligne à un questionnaire de
          23 questions (18 fermées, 5 ouvertes) et livraison d'un Rapport de Révélation Stratégique™ personnalisé
          (document éditorial et PDF). Aucun objet physique n'est expédié.
        </li>
        <li><strong>Public visé :</strong> dirigeantes et dirigeants d'entreprise, professionnels.</li>
      </ul>

      <h2>3. Prix et taxes</h2>
      <ul>
        <li><strong>Prix :</strong> 49 $ CA</li>
        <li><strong>Devise :</strong> CAD</li>
        <li><strong>Taxes applicables :</strong> <Val info={info} k="TAX_REGISTRATION_INFORMATION" /></li>
        <li>Le total exact incluant les taxes est affiché avant la confirmation du paiement.</li>
      </ul>

      <h2>4. Paiement</h2>
      <ul>
        <li><strong>Mode :</strong> Stripe (paiement sécurisé par carte bancaire, aucun compte requis).</li>
        <li><strong>Moment de conclusion :</strong> la transaction est conclue lorsque Stripe confirme le paiement.</li>
        <li>Aucune donnée de carte n'est stockée par Maison Beaudette™.</li>
      </ul>

      <h2>5. Livraison</h2>
      <ul>
        <li><strong>Méthode d'accès :</strong> lien privé transmis par courriel après paiement, également accessible depuis la plateforme.</li>
        <li><strong>Délai réel de génération :</strong> <Val info={info} k="REPORT_DELIVERY_TIME" /></li>
        <li><strong>Durée d'accès :</strong> <Val info={info} k="REPORT_ACCESS_DURATION" /></li>
        <li>Vous pouvez à tout moment demander de renvoyer le lien depuis la page « Retrouver ma lecture » ou en écrivant au soutien.</li>
      </ul>

      <h2>6. Assistance après achat</h2>
      <ul>
        <li>
          <strong>Paiement réussi sans accès :</strong> contactez le soutien à <Val info={info} k="SUPPORT_EMAIL" /> en indiquant
          le courriel utilisé lors de l'achat. Nous rétablirons l'accès dans les meilleurs délais.
        </li>
        <li>
          <strong>Échec de génération :</strong> si le rapport ne peut être généré pour une raison technique,
          nous corrigeons la situation ou offrons un nouvel accès sans frais additionnels.
        </li>
        <li>
          <strong>Achat en double :</strong> tout second achat inutile lié à un même dossier fera l'objet d'un remboursement.
        </li>
      </ul>

      <h2>7. Politique de remboursement</h2>
      <p>
        En cas de problème technique empêchant l'accès au parcours ou la génération du rapport,
        Maison Beaudette™ examinera la situation et offrira, selon le cas, une correction, un nouvel accès
        ou un remboursement, sous réserve des droits obligatoires applicables au consommateur.
      </p>
      <p>
        Le Rapport de Révélation Stratégique™ est un livrable éditorial personnalisé. Une fois généré et livré,
        il ne peut faire l'objet d'un simple droit de rétractation pour un produit numérique déjà consommé, sauf
        dispositions impératives de la loi applicable au consommateur.
      </p>
      <p><strong>Date d'entrée en vigueur de la politique de remboursement :</strong> <Val info={info} k="REFUND_POLICY_EFFECTIVE_DATE" /></p>

      <h2>8. Absence de garantie de résultat</h2>
      <p>
        Le Révélateur™ propose une lecture stratégique éditoriale à partir de vos réponses. Il ne remplace pas un
        accompagnement professionnel personnalisé ni un avis juridique, fiscal, financier ou comptable. Aucun
        résultat commercial n'est garanti.
      </p>

      <h2>9. Droits obligatoires du consommateur</h2>
      <p>
        Les présentes n'affectent pas les droits impératifs prévus par la Loi sur la protection du consommateur
        applicable et les autres lois d'ordre public.
      </p>

      <h2>10. Soutien</h2>
      <p>
        Courriel : <Val info={info} k="SUPPORT_EMAIL" /><br />
        Téléphone : <Val info={info} k="BUSINESS_PHONE" />
      </p>

      <MissingFieldsBlock info={info} />
    </LegalPage>
  );
}
